<template>
  <div class="flex-center position-ref full-height">
    <div style="padding-bottom: 50%;">
      <div style="text-align: center;"><img src="https://file.objectsdata.com/common/upiwapv2/img/failed.png"
                                            style="width: 260px;"></div>
      <div style="text-align: center; font-size: 28px; font-weight: 500; color: #c40000; margin: 20px;">Error</div>
      <div class="message" style="color: #3b3b3b;">The order payment failed.</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Error',
}
</script>
<style scoped> html, body {
  background-color: #fff;
  color: #636b6f;
  font-family: 'Nunito', sans-serif;
  font-weight: 100;
  height: 100vh;
  margin: 0;
}

.full-height {
  height: 100vh;
}

.flex-center {
  align-items: center;
  display: flex;
  justify-content: center;
}

.position-ref {
  position: relative;
}

.code {
  border-right: 2px solid;
  font-size: 26px;
  padding: 0 15px 0 15px;
  text-align: center;
}

.message {
  font-size: 18px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/fail.vue